import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FullLayoutComponent } from 'app/containers';
import { ListadoComponent } from 'app/modules/expedientes/listado/listado.component';
import { ExpedienteComponent } from 'app/modules/expedientes/expediente/expediente.component';
import { EvaluacionComponent } from './evaluacion/evaluacion.component';
import { EvaluacionRenovacionComponent } from './evaluacion-renovacion/evaluacion-renovacion.component';
import { UniversidadComponent } from './expediente/universidad/universidad.component';
import { AuthGuardDeva, AuthGuardUniv } from 'app/auth.guard';




const routes: Routes = [
  {
   path: '',
   redirectTo: '5',
   pathMatch: 'full'},
    { path: ':tipo', component: ListadoComponent, data: {title: 'EXPEDIENTE'}},
    { path: ':tipo/:idconvocatoria', component: ListadoComponent, data: {title: 'EXPEDIENTE'}},
    { path: ':tipo/:idconvocatoria/:idcentro',canActivate: [AuthGuardDeva],component: ExpedienteComponent, data: {title: 'EXPEDIENTE'}},
    { path: ':tipo/:idconvocatoria/:idcentro/autoinforme',canActivate: [AuthGuardDeva],component: UniversidadComponent, data: {title: 'EXPEDIENTE'}},
    //{ path: ':tipo/:idconvocatoria/:idcentro/documentacion',canActivate: [AuthGuardDeva],component: DocumentacionComponent, data: {title: 'EXPEDIENTE'}},
    { path: ':tipo/:idconvocatoria/:idcentro/:idtipoevaluacion/:idevaluador/renovacion',canActivate: [AuthGuardDeva], component: EvaluacionRenovacionComponent, data: {title: 'EVALUACION RENOVACION'}},
    { path: ':tipo/:idconvocatoria/:idcentro/:idtipoevaluacion/:idevaluador',canActivate: [AuthGuardDeva], component: EvaluacionComponent, data: {title: 'EVALUACION'}}
];



@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExpedientesRoutingModule { }





// WEBPACK FOOTER //
// /app/src/app/modules/expedientes/expedientes-routing.module.ts